import { render, staticRenderFns } from "./BlockPropertiesPanel.vue?vue&type=template&id=87ef82c8&scoped=true&"
import script from "./BlockPropertiesPanel.vue?vue&type=script&lang=js&"
export * from "./BlockPropertiesPanel.vue?vue&type=script&lang=js&"
import style0 from "./BlockPropertiesPanel.vue?vue&type=style&index=0&id=87ef82c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87ef82c8",
  null
  
)

export default component.exports